/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    Brevo?: any[];
  }
}

type Attributes = Record<string, string | number | boolean | undefined>;

function push(...args: any[]) {
  if (typeof window === "undefined") return;
  window.Brevo = window.Brevo || [];
  window.Brevo.push(args);
}

export function identify(email: string, attributes?: Attributes) {
  push("identify", {
    identifiers: { email_id: email },
    ...(attributes && { attributes }),
  });
}

export function track(eventName: string, properties?: Attributes) {
  // Brevo's sib.track signature is (name, contactAttributes, eventData, ...) —
  // properties belong in the 3rd slot, not the 2nd (contact attributes).
  push("track", eventName, undefined, properties);
}
